import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getProjects, createProject } from '../../services/project'

export const getProjectsAction = createAsyncThunk('projects/get', async (payload, { rejectWithValue }) => {
  try {
    const data = await getProjects(payload.pagination)

    return data.data
  } catch (e) {
    return rejectWithValue(e.response.data)
  }
})

export const createProjectAction = createAsyncThunk(
  'projects/create',
  async ({ name, description }, { rejectWithValue }) => {
    try {
      const response = await createProject({
        data: {
          data: {
            name,
            description,
          },
        },
      })

      return {
        id: response?.data?.data?.id,
        name,
        description,
        createdAt: response?.data?.data?.attributes?.createdAt,
        updatedAt: response?.data?.data?.attributes?.updatedAt,
      }
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const projectSlice = createSlice({
  name: 'project',
  initialState: {
    projects: [],
    selectedProject: null,
    pagination: {},
    isFetching: false,
    isSuccess: false,
    isAddSuccess: false,
    isError: false,
    errorMessage: '',
  },
  reducers: {
    clearState: (state) => {
      state.isError = false
      state.isSuccess = false
      state.isAddSuccess = false
      state.isFetching = false

      return state
    },
    setProject: (state, { payload }) => {
      state.selectedProject = payload.project
      return state
    },
  },
  extraReducers: {
    [getProjectsAction.fulfilled]: (state, data) => {
      state.projects = data.payload.data
      state.pagination = data.payload.meta.pagination
      state.isFetching = false
      state.isSuccess = true
      return state
    },
    [getProjectsAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [getProjectsAction.pending]: (state) => {
      state.isFetching = true
    },
    [createProjectAction.fulfilled]: (state, data) => {
      state.projects.push(data.payload)
      state.isFetching = false
      state.isAddSuccess = true
      return state
    },
    [createProjectAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
    },
    [createProjectAction.pending]: (state) => {
      state.isFetching = true
    },
  },
})

export const { clearState, setProject } = projectSlice.actions

export const projectSelector = (state) => state.project
